export default __webpack_public_path__ + "static/media/Avon_RGB_Logo.44260b0f.svg";